var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-center"},[_vm._v("This is under construction")])}
var staticRenderFns = []

export { render, staticRenderFns }